import { Injectable, inject } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { filter, first, tap, map } from 'rxjs/operators';
import { LoginService } from './login.service';
@Injectable({
  providedIn: 'root'
})
export class AuthGuard  {
  protected router = inject(Router);
  protected loginService = inject(LoginService);


  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ): Observable<boolean | UrlTree> {

    // When the user logs out, the state gets reset, and if we do
    // things like set the redirectUrl, it will blow and we don't
    // want to save teh redirect url anyway when the user logs out
    if (!this.loginService.isStateInitialized()) {
      return of(false);
    }

    // Save off redirectUrl
    // Wait for refreshToken or existing login session check to finish (in case app just loading)
    // if logged in return true
    // if not, redirect to /login (or wherever suppsoed to go... SSO etc) return false
    this.loginService.setRedirectUrl(state.url);
    return this.loginService.completedLoginStatus()
      .pipe(
        map(loginStatus => {
          if (!loginStatus.isLoggedIn) {
            this.router.navigate(['login']);
            return false;
          }
          return true;
        })
      )
  }

}
